export function formatGs(amount) {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) return 'Gs. 0';
  return `Gs. ${Math.round(num).toLocaleString('es-PY')}`;
}

export const ORDER_STATUS = {
  pendiente: { label: 'Pendiente', color: 'bg-amber-500/20 text-amber-400', step: 0 },
  cocina: { label: 'En cocina', color: 'bg-orange-500/20 text-orange-400', step: 1 },
  en_camino: { label: 'En camino', color: 'bg-blue-500/20 text-blue-400', step: 2 },
  entregado: { label: 'Entregado', color: 'bg-emerald-500/20 text-emerald-400', step: 3 },
  cancelado: { label: 'Cancelado', color: 'bg-red-500/20 text-red-400', step: -1 },
  rechazado: { label: 'Rechazado', color: 'bg-red-500/20 text-red-400', step: -1 },
};

export const DAYS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

/** Resolve any upload URL — normalizes /uploads/... to /api/static/uploads/... */
export function resolveUploadUrl(url) {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  // Ensure the path goes through the API proxy
  if (url.startsWith('/uploads/')) return `${API_BASE}/api/static${url}`;
  if (url.startsWith('/api/static/uploads/')) return `${API_BASE}${url}`;
  return `${API_BASE}${url}`;
}

/** Resolve product image URL. type: 'optimized' | 'thumb' */
export function productImg(imageUrl, type = 'optimized') {
  if (!imageUrl) return null;
  // Already a full URL (external)
  if (imageUrl.startsWith('http')) return imageUrl;
  // Local upload path: swap between optimized/thumbnails
  // Use /api/static/uploads route for K8s ingress routing
  if (imageUrl.includes('/uploads/products/')) {
    const filename = imageUrl.split('/').pop();
    if (type === 'thumb') return `${API_BASE}/api/static/uploads/products/thumbnails/${filename}`;
    return `${API_BASE}/api/static/uploads/products/optimized/${filename}`;
  }
  // Relative path  
  return `${API_BASE}${imageUrl}`;
}
